import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import ClaimForm from "Components/Form/ClaimForm";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import { addClaimValidation } from "core/Operations/ValidationSchema/claimValidationSchema";
import {
  useGetClaimById,
  useInsertClaimMutation,
  useUpdateClaimMutation,
} from "AppQuries/claim/claim-management";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { toast } from "core/Operations/toast";
import ImagePreview from "Components/UI/Image/ImagePreview";
import { Pdf } from "core/img/imagePath";
import { getCurrentFormattedDate } from "core/Operations/dateFormat";
import { useInsertAnnouncementMutation } from "AppQuries/company/announcement";
import AnnouncementForm from "./AnnouncementForm";
import { announcementValidation } from "core/Operations/ValidationSchema/settingsValidationSchema";
import { BackIcon } from "Components/UI/Icon/Icons";
const AddAnnouncement = () => {
  const userData = useSelector(loggedInUser);
  const { code } = useParams();

  const { mutate: addAnnouncement } = useInsertAnnouncementMutation();

  const methods = useForm({
    defaultValues: {
      companyCode: userData.companyCode,
      locationCode: userData.locationCode,
      modifyUser: userData.userName,
      modifyDate: getCurrentFormattedDate(),
      createUser: userData.userName,
      createDate: getCurrentFormattedDate(),
      isActive: true,
    },
    resolver: yupResolver(announcementValidation),
  });

  const navigate = useNavigate();

  const { setValue, handleSubmit } = methods;

  const onSubmit = (payload) => {
    console.log(payload);
    addAnnouncement(payload, {
      onSuccess: (data) => {
        if (data?.response === true) {
          toast.success(
            data?.errorMessage || "Announcement Added Successfully."
          );

          setTimeout(() => {
            navigate(`${all_routes.announcement_list}`);
          }, 1000);
        } else {
          toast.warning(data?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  //   if (isError) return <Error404 error={error} />;
  //   if (isGettingError) return <Error404 error={gettingError} />;
  //   if (isLoading || isSettingData) return <LoadingSpinner />;

  return (
    <div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Announcemet Management</h4>
                    <h6>Add your new Announcement </h6>
                  </div>
                </div>
                
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">Add Announcement</Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Save
                    </button>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="back">Back</Tooltip>}
                  >
                    <Link
                      to={`${all_routes.announcement_list}`}
                      className="btn btn-secondary"
                    >
                      <BackIcon className="me-2" />
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">Add Announcement</h4>
                    </div>
                    <div className="card-body">
                      <AnnouncementForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default AddAnnouncement;
